import { Component, inject, signal } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ProductQuickEditorComponent } from '../widgets/product-quick-editor/product-quick-editor.component';

@Component({
  selector: 'app-seller-template-edit-page',
  standalone: true,
  imports: [ProductQuickEditorComponent],
  template: `<main class="seller-template-edit-page"><app-product-quick-editor mode="listing" [editorOnly]="true" [initialTemplateID]="templateID()" /></main>`,
  styles: [`:host{display:block}.seller-template-edit-page{margin:0 auto;max-width:1240px}`]
})
export class SellerTemplateEditPage {
  private readonly route = inject(ActivatedRoute);
  protected readonly templateID = signal(Number(this.route.snapshot.paramMap.get('id') ?? 0) || 0);
}
